Drupal.behaviors.accordion = {
  attach(context) {
    // Selectors
    const items = Array.from(context.querySelectorAll(".js-accordion-item"));

    // Classes
    const itemToggle = ".js-accordion-item__toggle";
    const itemState = "data-accordion-expanded";
    const buttonState = "aria-expanded";

    // Function to expand an accordion item.
    const expand = (item, button) => {
      item.setAttribute(itemState, "true");
      button.setAttribute(buttonState, "true");
    };

    // Function to collapse an accordion item.
    const collapse = (item, button) => {
      item.setAttribute(itemState, "false");
      button.setAttribute(buttonState, "false");
    };

    // Function to collapse all but selected item.
    const collapseAllOthers = (currentItem) => {
      items.forEach((item) => {
        if (item !== currentItem) {
          const button = item.querySelector(itemToggle);
          collapse(item, button);
        }
      });
    };

    // Toggle accordion content when toggle is activated.
    items.forEach((item) => {
      const button = item.querySelector(itemToggle);

      if (button.getAttribute("data-accordion-processed")) return; // Skip if already processed

      // Hide all accordion content sections if JavaScript is enabled.
      collapse(item, button);

      button.addEventListener("click", () => {
        // Collapse all others on any button click.
        collapseAllOthers(item);

        // Toggle the item's state.
        if (button.getAttribute(buttonState) === "true") {
          collapse(item, button);
        } else {
          expand(item, button);
        }
      });

      button.setAttribute("data-accordion-processed", true); // Mark as processed
    });
  },
};
